import styled from "react-emotion";
import { themeGet } from "styled-system";
import { FlexRow } from "../misc";

export const Wrapper = styled(FlexRow)`
  padding: ${themeGet("space.3")}px 0;
`;

export const Checkbox = styled("input")`
  min-width: 24px;
  min-height: 24px;
  margin: 0 ${themeGet("space.2")}px;
  appearance: none;
  outline: none;
  box-shadow: 0 2px 6px rgba(184, 194, 204, 0.25);
  border: 1px solid ${themeGet("colors.greyLight")};
  border-radius: 50%;
  cursor: pointer;
  background-image: none;
  background-position: center center;
  background-size: 80%;
  background-repeat: no-repeat;

  &:checked {
    border-color: transparent;
    background-color: ${themeGet("colors.redLight")};
    background-image: url("data:image/svg+xml;utf8,<svg viewBox='0 0 10 9' xmlns='http://www.w3.org/2000/svg'><path d='M1 4.88l2.378 2.435L9.046 1.6' stroke-width='1.6' stroke='%23FFF' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/></svg>");
  }

  &:hover {
    background-image: url("data:image/svg+xml;utf8,<svg viewBox='0 0 10 9' xmlns='http://www.w3.org/2000/svg'><path d='M1 4.88l2.378 2.435L9.046 1.6' stroke-width='1.6' stroke='rgba(241,245,248,1)' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/></svg>");
  }
`;

export const Label = styled("span")`
  flex: 1;
  padding: 0 ${themeGet("space.4")}px;
  text-align: left;
  font-weight: 300;
  color: ${themeGet("colors.black")};
`;



// WEBPACK FOOTER //
// ../shop_main/components/checkbox/style.js